import { Icon, ICONS } from '@creditsights/styleguide-web';
import classNames from 'classnames/bind';
import React from 'react';
import styles from './HelpButton.module.scss';

const cx = classNames.bind(styles);

interface HelpButtonProps {
  onClick: Function;
}

const HelpButton = ({ onClick }: HelpButtonProps): React.ReactElement => {
  return (
    <div className={cx('body')} onClick={() => onClick()} data-testid="get-help-button">
      <Icon height={20} width={20} name={ICONS.GetHelp} />
      <div className={cx('text')}>Get Help</div>
    </div>
  );
};

export default HelpButton;
